export enum TypeDianEnums {
  aiu = 1,
  estandar = 2,
  mandato = 3
}
